import { NotificationSettings } from "@/components/Notifications/NotificationSettings";
import React from "react";
import { useParams } from "react-router";

const NotificationsPage: React.FC = () => {
  const params = useParams();
  const eventTypeId = params.eventTypeId || "-1";
  return <NotificationSettings eventTypeId={Number(eventTypeId)} />;
};

export default NotificationsPage;
